import {Grid} from '@primer/react-brand'

import {ContentfulFaqGroup} from '@github-ui/swp-core/components/contentful/ContentfulFaqGroup'
import type {PrimerComponentFaqGroup} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentFaqGroup'

import type {GenericSectionWithIds} from '../../../../brand/lib/types/contentful'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function FaqSection(props: Props) {
  const {contentfulContent} = props

  const faqComponent = contentfulContent.fields.content?.find(
    item => item.sys.contentType.sys.id === 'primerComponentFaqGroup',
  ) as PrimerComponentFaqGroup | undefined

  return (
    /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
    <section id="faq" className="lp-Section tmp-pb-8 tmp-pb-md-12 tmp-pt-8 tmp-pt-md-12">
      <Grid>
        {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
        <Grid.Column span={12} className="lp-FAQs">
          {faqComponent ? <ContentfulFaqGroup component={faqComponent} /> : null}
        </Grid.Column>
      </Grid>
    </section>
  )
}
